import {
  IClient,
  IClientEditProps,
  IClientRegisterProps,
  IClientsProps,
} from "interfaces/Client";
import {
  activeClient,
  createClientsService,
  deleteClient,
  editClientsService,
} from "../ClientService";

export function handleClientActiveSubmit({
  client,
}: IDeleteClientRegisterProps) {
  if (client) {
    activeClient(client.id)
      .then((res) => {
        localStorage.setItem("message", "Cliente ativado com sucesso");
        window.location.reload();
      })
      .catch((err) => {
        console.log(err.response);
      });
  } else {
    console.log("no client is selected");
  }
}

export function handleClientDeleteSubmit({
  client,
}: IDeleteClientRegisterProps) {
  if (client) {
    deleteClient(client.id)
      .then((res) => {
        localStorage.setItem("message", "Cliente desativado com sucesso");
        window.location.reload();
      })
      .catch((err) => {
        console.log(err.response);
      });
  } else {
    console.log("no client is selected");
  }
}

export async function handleClientRegisterSubmit({
  userName,
  password,
  rg,
  cpf,
  name,
  productName,
  cnpj,
  tradingName,
  managerName,
  email,
  details,
  type,
  regions,
  productRegions,
  minimumBilling,
  servicesIds,
}: IClientRegisterProps) {
  return await createClientsService({
    userName,
    password,
    rg,
    cpf,
    name,
    productName,
    cnpj,
    tradingName,
    managerName,
    productRegions,
    minimumBilling,
    email,
    details,
    type,
    regions,
    servicesIds,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err.response) return err.response;
      return err;
    });
}

// export async function handleClientRegisterSubmit({
//   name,
//   id,
//   cnpj,
//   corporativeEmail,
//   managerName,
//   tradingName,
//   userId,
//   productName,
//   regions,
//   details,
//   servicesIds,
//   type,
//   closeModal,
// }: IClientsProps) {
//   return await createClientsService({
//     name,
//     id,
//     cnpj,
//     corporativeEmail,
//     managerName,
//     tradingName,
//     userId,
//     productName,
//     regions,
//     details,
//     servicesIds,
//     type,
//   })
//     .then((res) => {
//       window.location.reload();
//     })
//     .catch((err) => {
//       console.log(err.response);
//       return err.response;
//     });
// }

export async function handleClientRegisterEdit({
  // user,
  clientData,
  regions,
  servicesIds,
  productRegions,
  product,
}: IClientEditProps) {
  return await editClientsService({
    // user,
    clientData,
    regions,
    product,
    servicesIds,
    productRegions,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

interface IDeleteClientRegisterProps {
  client?: IClient;
}
